import { createContext } from 'react';

const BreedContext = createContext();

export default BreedContext;